<mat-stepper #orderStepper [linear]="false" orientation="horizontal" [animationDuration]="animationDuration" [selectedIndex]="selectedIndex" (selectionChange)="onStepChange($event)">
  @for (step of stepper?.steps; track step) {
    <mat-step [state]="getStepIcon(step)" completed="false">
      <ng-template matStepLabel>
        <label [ngClass]="stepper?.steps?.indexOf(step) === selectedIndex ? '' : ''">{{ (stepTitleKeys[step.title] ?? step.title) | transloco }}</label>
      </ng-template>
      <!-- Here we dynamically load content based on step.content -->
      <ng-template #appDynamicHost></ng-template>
      <!-- Navigation buttons -->
      <div class="flex-container padding-top">
        @if (selectedIndex != 0) {
          <button
            mat-raised-button
            (click)="previousStep(orderStepper)"
            class="apply-padding flex-item form-field previous-button"
            [attr.aria-label]="'orders.previousStepButton' | transloco"
            [attr.data-testid]="'previous-step-button-' + step.title.replaceAll(' ', '-').toLowerCase()"
            >
            {{ 'common.buttons.previous' | transloco }}
          </button>
        }
        @if (selectedIndex == 0) {
          <span class="spacer"></span>
        }
        <span class="spacer"></span>
        <span class="spacer"></span>
        <span class="spacer"></span>
        <span class="spacer"></span>
        @if (order.orderStatusTypeID == 'Invalid') {
          <button
            mat-raised-button
            (click)="cancelInvalid()"
            color="warn"
            class="apply-padding flex-item form-field"
            [attr.aria-label]="'orders.cancelInvalidButton' | transloco"
            [attr.data-testid]="'cancel-step-button-' + step.title.replaceAll(' ', '-').toLowerCase()"
            >
            {{ 'common.buttons.cancel' | transloco }}
          </button>
        }
        <span class="spacer"></span>
        <button
          mat-raised-button
          (click)="nextStep(orderStepper)"
          color="primary"
          class="apply-padding flex-item form-field"
          [attr.aria-label]="'orders.nextStepButton' | transloco"
          [disabled]="shouldDisableSubmitButton"
          [attr.data-testid]="'next-step-button-' + step.title.replaceAll(' ', '-').toLowerCase()"
          >
          {{ (finalStepIsSelected ? finalStepWording : 'common.buttons.next') | transloco }}
        </button>
        <!-- [class.spinner]="this.isSaving"
        [disabled]="this.isSaving" -->
      </div>
      <!-- <button mat-button matStepperPrevious>Back</button>
      <button mat-button matStepperNext>Next</button> -->
    </mat-step>
  }

  <!-- Icon overrides. -->
  <ng-template matStepperIcon="edit">
    <mat-icon>edit</mat-icon>
  </ng-template>
  <ng-template matStepperIcon="validated">
    <mat-icon>check</mat-icon>
  </ng-template>
  <ng-template matStepperIcon="error">
    <mat-icon>close</mat-icon>
  </ng-template>
</mat-stepper>